import Swal, { SweetAlertIcon } from 'sweetalert2';

export class AlertUtil {
  /**
   * Show a confirmation dialog
   */
  static async confirm(
    title: string,
    message: string,
    confirmText: string = 'Yes',
    cancelText: string = 'Cancel',
    icon: SweetAlertIcon = 'warning'
  ) {
    return Swal.fire({
      title,
      html: message,
      icon,
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      buttonsStyling: false, // disable SweetAlert default styles
      customClass: {
        container: 'swal-on-top',
        confirmButton: 'btn btn-secondary text-white mx-2',
        cancelButton: 'btn btn-outline-primary mx-2',
        actions: 'd-flex justify-content-end gap-2',
      },
    });
  }

  /**
   * Success alert
   */
  static success(
    message: string = 'Operation completed successfully!',
    title: string = 'Success'
  ) {
    return Swal.fire({
      title,
      text: message,
      icon: 'success',
      timer: 1500,
      showConfirmButton: false,
      buttonsStyling: false,
      customClass: { container: 'swal-on-top' },
    });
  }

  /**
   * Error alert
   */
  static error(
    message: string = 'Something went wrong!',
    title: string = 'Error'
  ) {
    return Swal.fire({
      title,
      text: message,
      icon: 'error',
      confirmButtonText: 'OK',
      buttonsStyling: false,
      customClass: {
        container: 'swal-on-top',
        confirmButton: 'btn btn-primary',
      },
    });
  }

  /**
   * Info alert
   */
  static info(message: string, title: string = 'Information') {
    return Swal.fire({
      title,
      text: message,
      icon: 'info',
      confirmButtonText: 'OK',
      buttonsStyling: false,
      customClass: {
        container: 'swal-on-top',
        confirmButton: 'btn btn-primary',
      },
    });
  }

  static successConfirm(
    message: string,
    title: string = 'Success',
    confirmText: string = 'OK'
  ) {
    return Swal.fire({
      title,
      html: message,
      icon: 'success',
      showConfirmButton: true,
      confirmButtonText: confirmText,
      buttonsStyling: false,
      customClass: {
        container: 'swal-on-top',
        confirmButton: 'btn btn-primary',
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }

  static warningConfirm(
    message: string,
    title: string = 'Warning',
    confirmText: string = 'OK'
  ) {
    return Swal.fire({
      title,
      html: message,
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: confirmText,
      buttonsStyling: false,
      customClass: {
        container: 'swal-on-top',
        confirmButton: 'btn btn-primary',
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }

  static errorConfirm(
    message: string,
    title: string = 'Error',
    confirmText: string = 'OK'
  ) {
    return Swal.fire({
      title,
      html: message,
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: confirmText,
      buttonsStyling: false,
      customClass: {
        container: 'swal-on-top',
        confirmButton: 'btn btn-primary',
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
}
